import "UI/Template";
import "./Element";

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Element
 */
UI.Widget.Forms.Control.Range = Class(UI.Widget.Forms.Control.Element, /** @lends UI.Widget.Forms.Control.Range.prototype */ {
    template: "UI/Widget/Forms/Control/Range/Control",
    /**
     * @protected
     * @type {$.<HTMLElement>}
     */
    $input: null,
    /**
     * @protected
     * @type {$.<HTMLElement>}
     */
    $placeholder: null,

    createElement()
    {
        this.ParentCall();

        this.$element = UI.Template.$render(this.template);

        this.$input = this.$element.find(".slider");
        this.$placeholder = this.$element.find(".placeholder");
    },

    insertElement()
    {
        this.ParentCall();

        const min = parseFloat(Util.coalesce(this.$control.attr("min"), 0));

        this.$input.slider({
            min: min,
            max: parseFloat(Util.coalesce(this.$control.attr("max"), 100)),
            step: parseFloat(Util.coalesce(this.$control.attr("step"), 1)),
            units: Util.String.coalesce(this.$control.attr('units')),
            range: Util.String.coalesce(this.$control.attr('range'), 'min'),
            value: Util.coalesce(this.getValue(), this.$control.attr('html-value'), min),
            animate: 200,
            disabled: this.disabled
        });

        const onInput = this.$control.attr('on-input');
        const onChange = this.$control.attr('on-change');
        const units = Util.String.coalesce(this.$control.attr("units"));

        this.$input.on('slide', (evt, ui) => {
            this.updatePlaceholder(ui.value);

            evt.value = ui.value;

            if (_.isFunction(this.parent[onInput])) {
                this.parent[onInput](evt);
            }
        }).on('slidechange', (evt, ui) => {
            this.setValue(ui.value);

            evt.value = ui.value;

            if (_.isFunction(this.parent[onChange])) {
                this.parent[onChange](evt);
            }
        });
    },

    updateElement(value)
    {
        this.$input.slider('value', parseFloat(Util.coalesce(value, this.$input.slider('option', 'value'))));
        this.updatePlaceholder(value);
    },

    updatePlaceholder(value)
    {
        const units = Util.String.coalesce(this.$control.attr("units"));
        value = Util.coalesce(value, this.$input.slider('option', 'value'));

        if (this.$placeholder.timeOut) {
            clearTimeout(this.$placeholder.timeOut);
            delete this.$placeholder.timeOut;
        }

        this.$placeholder.timeOut = setTimeout(() => this.$placeholder.removeClass("active"), 750);

        this.$placeholder.text(value + units);
        this.$placeholder.addClass("active");
    },

    removeElement()
    {
        this.$input = null;
        this.$placeholder = null;

        return this.ParentCall();
    }
});
